import { render, staticRenderFns } from "./VirtualAccountList.vue?vue&type=template&id=9d5166e6&scoped=true"
import script from "./VirtualAccountList.vue?vue&type=script&lang=js"
export * from "./VirtualAccountList.vue?vue&type=script&lang=js"
import style0 from "./VirtualAccountList.vue?vue&type=style&index=0&id=9d5166e6&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9d5166e6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/pagsmile/front-end/pagsmile-dashboard/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('9d5166e6')) {
      api.createRecord('9d5166e6', component.options)
    } else {
      api.reload('9d5166e6', component.options)
    }
    module.hot.accept("./VirtualAccountList.vue?vue&type=template&id=9d5166e6&scoped=true", function () {
      api.rerender('9d5166e6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/VirtualAccount/VirtualAccountList.vue"
export default component.exports